<section>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-9">
        <div class="row">
          <h1>API Keys</h1>
          <p>
            Create up to {{ keyLimit }} API Keys that can be used to access
            HUNTER services and content. Learn more in our
            <a class="docUrl" [href]="apiDocUrl" target="_blank"
              >Intel 471 HUNTER API Documentation</a
            >.
          </p>
        </div>
        <div *ngIf="apiKeys$ | async as apiKeys">
          <div class="row">
            <form *ngIf="apiKeys.keys.length < keyLimit; else maxKeysMessage">
              <label>Create API Key</label>
              <kendo-textbox
                #keyName
                [style.width.px]="200"
                placeholder="Key Name"
              ></kendo-textbox>
              <button
                themeColor="primary"
                size="medium"
                (click)="onCreateKey(keyName.value)"
                kendoButton
                [disabled]="!keyName.value || keyName.value.length < 0"
              >
                Create
              </button>
            </form>

            <ng-template #maxKeysMessage>
              <p>
                The maximium number of keys has been reached, remove a key below
                to create a new key.
              </p>
            </ng-template>
          </div>
          <div class="row keys" *ngIf="apiKeys; else loading">
            <h2>Created Keys</h2>
            <kendo-grid
              [data]="apiKeys.keys"
              kendoGridSelectBy="id"
              [pageSize]="20"
              [pageable]="false"
              [sortable]="false"
              [groupable]="false"
              [selectable]="false"
              [reorderable]="false"
              [resizable]="true"
            >
              <kendo-grid-column field="name" title="Name">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.name }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="createdAt" title="Created">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.createdAt | date: 'short' }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column
                [width]="100"
                [sortable]="false"
                field="id"
                title="Delete"
              >
                <ng-template kendoGridCellTemplate let-dataItem>
                  <button
                    themeColor="error"
                    fillMode="outline"
                    icon="trash"
                    id="trash"
                    (click)="onRemoveKey(dataItem.id)"
                    kendoButton
                  ></button>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
          <ng-template #loading>
            <kendo-loader type="pulsing" themeColor="primary" size="large">
            </kendo-loader>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</section>
